import { useQuery } from '@tanstack/react-query';
import { dbClient, normalizeRpcResponse } from '@/services/db-client';

export type GestionBucket = {
  total: number;
  received?: number;
  awaitingReview: number;
  inProgress?: number;
  delivered: number;
  failed: number;
  refunded?: number;
  serviceFeeCents: number;
  officialFeeCents?: number;
};

export type GestionAnalytics = {
  days: number;
  licenseOrders: GestionBucket;
  navigationOrders: GestionBucket;
  bluefinLeads: { total: number; test: number };
};

export function useGestionAnalytics(days: number) {
  return useQuery<GestionAnalytics>({
    queryKey: ['admin', 'gestion-analytics', days],
    queryFn: async () => {
      const { data, error } = await dbClient.rpc<GestionAnalytics>('get_gestion_license_analytics', {
        p_days: days,
      });
      if (error) throw new Error(error.message);
      const rows = normalizeRpcResponse(data);
      const first = Array.isArray(rows) ? rows[0] : rows;
      const payload =
        first && typeof first === 'object' && 'licenseOrders' in first
          ? first
          : first && typeof first === 'object' && 'get_gestion_license_analytics' in first
            ? (first as { get_gestion_license_analytics: GestionAnalytics }).get_gestion_license_analytics
            : first;
      if (!payload || typeof payload !== 'object' || !('licenseOrders' in payload)) {
        throw new Error('Analítica de gestiones vacía');
      }
      return payload as GestionAnalytics;
    },
    staleTime: 60_000,
  });
}
